export default "__VITE_ASSET__GSTDr40d__"